import React from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import "./WorkOrderCreateWorkItemCreate.css";
import { useWorkOrders } from "../../data/WorkOrdersHook";
import { useWorkItemTemplates } from "../../data/WorkItemTemplatesHook";
import DomesticFieldReactiveEntry from "./entry/DomesticFieldReactiveEntry";
import DomesticCMVEntry from "./entry/DomesticCMVEntry";
import DisconnectionEntry from "./entry/DisconnectionEntry";
import ReconnectionEntry from "./entry/ReconnectionEntry";

function WorkOrderCreateWorkItemCreate() {
  const { getEntry, setEntry } = useWorkOrders();
  const { getCurrentWorkItemTemplates } = useWorkItemTemplates();
  const workItemTemplates = getCurrentWorkItemTemplates();

  const handleUpdateWorkItemTemplate = (e) => {
    const newWorkItemTemplate = workItemTemplates.find(
      (template) => template.id === e.target.value
    );
    const current = getEntry();
    const revised = {
      ...current,
      workitemtemplateid: newWorkItemTemplate.id,
      workitemtemplateref: newWorkItemTemplate.ref,
    };
    setEntry(revised);
  };

  const components = {
    DomesticFieldReactive: DomesticFieldReactiveEntry,
    DomesticCMV: DomesticCMVEntry,
    Disconnection: DisconnectionEntry,
    Reconnection: ReconnectionEntry,
  };

  const { workitemtemplateid, workitemtemplateref } = getEntry();

  const WorkItemForm = components[workitemtemplateref];

  return (
    <Container className="work-order-entry-work-item-entry-container">
      <Row>
        <Form.Group className="mb-3" controlId="workItemTemplate">
          <Form.Label>Work Item Template</Form.Label>
          <Form.Select
            value={workitemtemplateid}
            onChange={handleUpdateWorkItemTemplate}
            required
          >
            {workItemTemplates.map((template) => (
              <option key={template.id} value={template.id}>
                {template.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Row>
      <Row>
        <Col>{WorkItemForm && <WorkItemForm />}</Col>
      </Row>
    </Container>
  );
}

export default WorkOrderCreateWorkItemCreate;
